export default __webpack_public_path__ + "locales/lv/VersionHistory.json?hash=b5a63568f87f7abcec2cea6d13af9bd0";